import React from "react";
import * as Components from "../../components/all";
import charImage from "../../assets/character.png";
// chart
import {
	Chart as ChartJS,
	CategoryScale,
	LinearScale,
	PointElement,
	LineElement,
	Title,
	Tooltip,
	Filler,
	Legend,
	ArcElement,
	BarElement,
} from "chart.js";
import { Bar, Doughnut, Line } from "react-chartjs-2";

ChartJS.register(
	CategoryScale,
	LinearScale,
	PointElement,
	LineElement,
	ArcElement,
	BarElement,
	Title,
	Tooltip,
	Filler,
	Legend
);

export default function AdminAssesment() {
	// doughnut chart
	const doughnutData = {
		labels: ["Total Female Students 45,000", "Total Male Students 45,000"],
		datasets: [
			{
				data: [3, 1],
				backgroundColor: ["#EC7C8A", "#FF8F6B"],
				borderWidth: 0,
			},
		],
	};

	const doughnutOptions = {
		cutout: 115,
		plugins: {
			legend: {
				display: false,
			},
		},
	};

	// line chart
	const lineData = {
		labels: [
			"Jan",
			"Feb",
			"Mar",
			"Apr",
			"May",
			"Jun",
			"Jul",
			"Aug",
			"Sep",
			"Oct",
			"Nov",
			"Dec",
		],
		datasets: [
			{
				fill: true,
				lineTension: 0.5,
				data: [0, 50, 41, 55, 50, 65, 60, 75, 70, 85, 80, 10],
				borderColor: "#13A7DD",
				backgroundColor: "rgba(19, 167, 221, 0.06)",
				borderWidth: 2,
				pointBorderColor: "black",
				pointBackgroundColor: "white",
			},
		],
	};

	const lineOptions = {
		responsive: true,
		maintainAspectRatio: false,
		plugins: {
			legend: {
				display: false,
			},
			title: {
				display: false,
			},
		},
		scales: {
			x: {
				display: true,
				grid: {
					display: false,
				},
				border: {
					display: false,
				},
			},
			y: {
				display: true,
				grid: {},
				border: {
					display: false,
					dash: [2, 4],
				},
				ticks: {
					callback: function (value) {
						return value.toFixed(0) + "%";
					},
					maxTicksLimit: 6,
				},
			},
		},
		elements: {
			point: {
				radius: 4,
			},
		},
	};

	return (
		<div className="AdminAssesment bg-[#F7F9FF] flex items-stretch h-screen max-h-screen overflow-hidden">
			{/* Sidebar */}
			<Components.Sidebar page={"assesment"} />

			{/* Right */}
			<div className="flex-1 flex flex-col items-stretch overflow-hidden">
				{/* Navbar */}
				<Components.AdminNavbar page={"Pre and Post assesment"} />
				{/* Page */}
				<div className="p-4 flex-1 h-full overflow-auto">
					{/* banner */}
					<div className="relative flex bg-white py-3 px-8 items-center rounded-md shadow">
						{/* text */}
						<div className="flex flex-col items-start">
							<Components.SubHeading className="!text-2xl text-left">
								Student ability to use{" "}
								<span className="text-[#F38315]"> AI to learn various</span>{" "}
								<br /> concepts or have virtual fields
							</Components.SubHeading>

							<button className="bg-[#F38315] rounded-full px-4 py-1 text-white mt-4">
								Connect to AI
							</button>
						</div>

						{/* characters svg */}
						<img src={charImage} alt="charim" className="ml-auto mr-16" />

						{/* circle svg */}
						<svg
							className="absolute top-0 right-0"
							width="30"
							height="30"
							viewBox="0 0 36 36"
							fill="none"
							xmlns="http://www.w3.org/2000/svg"
						>
							<circle
								opacity="0.6"
								cx="18"
								cy="18"
								r="18"
								fill="#F38315"
								fill-opacity="0.4"
							/>
						</svg>
					</div>

					{/* bottom row */}
					<div className="mt-4 flex justify-between flex-wrap">
						{/* left card */}
						<div className="h-96 w-full xl:w-[35%] mt-4 bg-white flex flex-col p-4 rounded-md shadow">
							{/* heading and select */}
							<div className="flex justify-between mb-2">
								<Components.Paragraph className="!text-lg !font-bold">
									Multiply Quiz
								</Components.Paragraph>

								<Components.Paragraph className="!text-lg !font-bold !text-[#F38315]">
									Go to AI
								</Components.Paragraph>
							</div>

							{/* text and checkboxes */}
							<div className="flex flex-col justify-center flex-1 w-full overflow-hidden">
								<p className="text-[#8C9295] text-sm text-left">
									Lorem ipsum dolor sit amet consectetur. Accumsan praesent
									potenti felis id felis praesent leo ipsum.?
								</p>

								<div className="flex mt-6">
									<input
										type="checkbox"
										name=""
										id=""
										className="rounded-full appearance-none h-4 w-4 border
										bg-[#E5E1E1] border-gray-300 checked:bg-[#F38315] checked:border-transparent focus:outline-none"
									/>
									<p className="text-sm ml-2">
										Lorem ipsum dolor sit amet consectetur.{" "}
									</p>
								</div>

								<div className="flex mt-2">
									<input
										type="checkbox"
										name=""
										id=""
										className="rounded-full appearance-none h-4 w-4 border
										bg-[#E5E1E1] border-gray-300 checked:bg-[#F38315] checked:border-transparent focus:outline-none"
									/>
									<p className="text-sm ml-2">
										Lorem ipsum dolor sit amet consectetur.{" "}
									</p>
								</div>

								<div className="flex mt-2">
									<input
										type="checkbox"
										name=""
										id=""
										className="rounded-full appearance-none h-4 w-4 border
										bg-[#E5E1E1] border-gray-300 checked:bg-[#F38315] checked:border-transparent focus:outline-none"
									/>
									<p className="text-sm ml-2">
										Lorem ipsum dolor sit amet consectetur.{" "}
									</p>
								</div>

								<div className="flex mt-2">
									<input
										type="checkbox"
										name=""
										id=""
										className="rounded-full appearance-none h-4 w-4 border
										bg-[#E5E1E1] border-gray-300 checked:bg-[#F38315] checked:border-transparent focus:outline-none"
									/>
									<p className="text-sm ml-2">
										Lorem ipsum dolor sit amet consectetur.{" "}
									</p>
								</div>

								<div className="flex mt-2">
									<input
										type="checkbox"
										name=""
										id=""
										className="rounded-full appearance-none h-4 w-4 border
										bg-[#E5E1E1] border-gray-300 checked:bg-[#F38315] checked:border-transparent focus:outline-none"
									/>
									<p className="text-sm ml-2">
										Lorem ipsum dolor sit amet consectetur.{" "}
									</p>
								</div>

								<div className="flex mt-2">
									<input
										type="checkbox"
										name=""
										id=""
										className="rounded-full appearance-none h-4 w-4 border
										bg-[#E5E1E1] border-gray-300 checked:bg-[#F38315] checked:border-transparent focus:outline-none"
									/>
									<p className="text-sm ml-2">
										Lorem ipsum dolor sit amet consectetur.{" "}
									</p>
								</div>

								{/* buttons */}
								<div className="flex justify-center mt-5">
									<button className="border border-[#F38315] px-4 py-1 rounded-full text-[#F38315] text-sm">
										Previous Quiz
									</button>

									<button className="ml-3 px-4 py-1 rounded-full text-white bg-[#F38315] text-sm">
										Submit Quiz
									</button>
								</div>
							</div>
						</div>

						{/* right card */}
						<div className="h-96 w-full xl:w-auto flex-1 mt-3 xl:mt-4 xl:ml-4 bg-white flex flex-col p-4 rounded-md shadow">
							{/* heading and select */}
							<div className="flex justify-between">
								<Components.Paragraph className="!text-lg !font-bold">
									Skills
								</Components.Paragraph>

								<div className="flex items-center">
									<svg
										width="20"
										height="20"
										viewBox="0 0 24 24"
										fill="none"
										xmlns="http://www.w3.org/2000/svg"
									>
										<path
											d="M11 17H13V13H17V11H13V7H11V11H7V13H11V17ZM12 22C10.6167 22 9.31667 21.7373 8.1 21.212C6.88333 20.6867 5.825 19.9743 4.925 19.075C4.025 18.175 3.31267 17.1167 2.788 15.9C2.26333 14.6833 2.00067 13.3833 2 12C2 10.6167 2.26267 9.31667 2.788 8.1C3.31333 6.88333 4.02567 5.825 4.925 4.925C5.825 4.025 6.88333 3.31267 8.1 2.788C9.31667 2.26333 10.6167 2.00067 12 2C13.3833 2 14.6833 2.26267 15.9 2.788C17.1167 3.31333 18.175 4.02567 19.075 4.925C19.975 5.825 20.6877 6.88333 21.213 8.1C21.7383 9.31667 22.0007 10.6167 22 12C22 13.3833 21.7373 14.6833 21.212 15.9C20.6867 17.1167 19.9743 18.175 19.075 19.075C18.175 19.975 17.1167 20.6877 15.9 21.213C14.6833 21.7383 13.3833 22.0007 12 22Z"
											fill="#A7AFB2"
										/>
									</svg>

									<Components.Paragraph className="!text-sm mt-1 !ml-1.5">
										Add Skill
									</Components.Paragraph>
								</div>
							</div>

							{/* graph */}
							<div className="flex-1 w-full overflow-hidden mt-6">
								{/* 1 */}
								<div className="flex items-end mb-2">
									<svg
										width="40"
										height="40"
										viewBox="0 0 40 40"
										fill="none"
										xmlns="http://www.w3.org/2000/svg"
									>
										<g clip-path="url(#clip0_38_1349)">
											<path
												d="M28.2812 35.3125H25.9375V32.9688H14.2188V35.3125H11.875C10.5805 35.3125 9.53125 36.3618 9.53125 37.6562V38.8281C9.53125 39.4753 10.0559 40 10.7031 40H29.4531C30.1003 40 30.625 39.4753 30.625 38.8281V37.6562C30.625 36.3618 29.5757 35.3125 28.2812 35.3125ZM9.53125 7.45469V20.6623C10.4615 20.4361 11.4154 20.3216 12.3728 20.3213C14.6685 20.3213 16.9448 20.9782 18.9062 22.2485V9.53406C15.7343 7.0039 12.572 6.51601 9.53125 7.45469ZM21.25 9.53406V22.2484C24.0263 20.4505 27.4287 19.8852 30.625 20.6623V7.45469C27.5598 6.50914 24.4038 7.01836 21.25 9.53406Z"
												fill="#F29CA7"
											/>
											<path
												d="M36.4844 0H3.51562C1.57703 0 0 1.57703 0 3.51562V27.1094C0 29.048 1.57703 30.625 3.51562 30.625H36.4844C38.423 30.625 40 29.048 40 27.1094V3.51562C40 1.57703 38.423 0 36.4844 0ZM32.9688 22.2656C32.9688 22.6547 32.7753 23.0175 32.4538 23.2361C32.131 23.4535 31.7202 23.4993 31.362 23.354C28.1393 22.0642 24.4531 22.6102 21.742 24.7799C20.703 25.6109 20.5492 25.7812 20.0781 25.7812C19.6048 25.7812 19.4498 25.6081 18.4141 24.7799C15.7041 22.6102 12.0192 22.0666 8.79422 23.354C8.43484 23.4959 8.02516 23.4513 7.70242 23.2361C7.54394 23.1286 7.41417 22.984 7.32442 22.8148C7.23467 22.6457 7.18766 22.4571 7.1875 22.2656V6.62727C7.18753 6.39298 7.25777 6.16407 7.38914 5.97008C7.52051 5.77608 7.70699 5.6259 7.92453 5.53891C11.7536 4.00969 16.2941 4.44414 20.0781 7.46969C23.8185 4.47898 28.3557 3.99156 32.2317 5.53891C32.4492 5.62592 32.6357 5.77611 32.7671 5.97009C32.8985 6.16408 32.9687 6.39298 32.9688 6.62727V22.2656Z"
												fill="#F29CA7"
											/>
										</g>
										<defs>
											<clipPath id="clip0_38_1349">
												<rect width="40" height="40" fill="white" />
											</clipPath>
										</defs>
									</svg>

									<div className="flex-1 pl-6 pr-16">
										<div className="flex text-[#707070] text-sm justify-between">
											<p>E-Learning</p>
											<p>45%</p>
										</div>
										<div class="w-full bg-[#F3EDED] rounded-full h-4">
											<div
												class="bg-[#F29CA7] h-4 rounded-full"
												style={{ width: "45%" }}
											></div>
										</div>
									</div>

									<svg
										width="24"
										height="24"
										viewBox="0 0 24 24"
										fill="none"
										xmlns="http://www.w3.org/2000/svg"
									>
										<path
											d="M7.1499 21.1C6.8999 20.85 6.7749 20.554 6.7749 20.212C6.7749 19.87 6.8999 19.5743 7.1499 19.325L14.4749 12L7.1249 4.65C6.89157 4.41667 6.7749 4.125 6.7749 3.775C6.7749 3.425 6.8999 3.125 7.1499 2.875C7.3999 2.625 7.6959 2.5 8.0379 2.5C8.3799 2.5 8.67557 2.625 8.9249 2.875L17.3249 11.3C17.4249 11.4 17.4959 11.5083 17.5379 11.625C17.5799 11.7417 17.6006 11.8667 17.5999 12C17.5999 12.1333 17.5789 12.2583 17.5369 12.375C17.4949 12.4917 17.4242 12.6 17.3249 12.7L8.8999 21.125C8.66657 21.3583 8.3789 21.475 8.0369 21.475C7.6949 21.475 7.39924 21.35 7.1499 21.1Z"
											fill="#A7AFB2"
										/>
									</svg>
								</div>

								{/* 2 */}
								<div className="flex items-end mb-2">
									<svg
										width="40"
										height="40"
										viewBox="0 0 40 40"
										fill="none"
										xmlns="http://www.w3.org/2000/svg"
									>
										<path
											fill-rule="evenodd"
											clip-rule="evenodd"
											d="M19.6453 26.0758C13.5822 21.0361 10.3449 14.3623 10.264 6.74008C14.0489 5.6164 17.2384 3.9643 20.0017 1.6993C22.7613 3.9643 25.9508 5.6164 29.7357 6.74008C29.6439 13.9033 26.0685 20.7487 19.6453 26.0758ZM36.1553 12.8707C36.1957 11.596 36.0083 11.348 36.0009 11.338C35.8792 11.197 35.8473 11.0985 35.6224 11.0617C34.4129 10.969 34.091 12.7034 33.9431 13.4902C33.9064 13.7993 33.6013 16.2002 33.1163 19.9439C33.0686 20.5466 32.2013 22.3993 30.9704 23.0945C31.6318 25.3794 30.3677 26.1452 29.0265 26.9529C28.1814 27.463 27.226 28.0413 26.5094 29.1C26.4359 29.2117 26.311 29.2719 26.1861 29.2719C25.8817 29.2719 25.6851 28.9252 25.8627 28.663C26.6748 27.4615 27.7551 26.8085 28.626 26.2841C29.9415 25.4882 30.7058 25.027 30.2391 23.3684C26.7372 24.43 24.5472 26.408 22.9597 29.9212C22.574 30.9612 22.6364 32.3395 22.7172 33.9328H29.7577C29.754 32.8198 29.8239 30.9068 30.3457 30.2207C30.5979 29.8871 32.6055 28.3011 33.3074 27.6805C34.079 26.9863 34.5494 26.3348 34.8287 25.5749L34.8802 25.3754C35.1705 24.2498 35.6151 22.5485 35.8136 18.48C35.8172 18.2052 35.8504 17.7591 35.8981 17.0859C35.9605 16.1727 36.0561 14.7929 36.1516 12.909L36.1553 12.8707ZM31.9111 35.1825V37.8323C31.9111 38.0906 31.7016 38.3008 31.4408 38.3008H22.0595C21.8022 38.3008 21.5928 38.0906 21.5928 37.8323V35.1825C21.5928 34.9241 21.8022 34.714 22.0595 34.714H31.4408C31.7016 34.714 31.9111 34.9241 31.9111 35.1825ZM18.4069 37.8323C18.4069 38.0906 18.1975 38.3008 17.9403 38.3008H8.55903C8.30185 38.3008 8.08864 38.0906 8.08864 37.8323V35.1825C8.08864 34.9241 8.30177 34.714 8.55903 34.714H17.9403C18.1975 34.714 18.4069 34.9241 18.4069 35.1825V37.8323ZM9.65411 30.2207C10.1759 30.9067 10.2457 32.8198 10.242 33.9328H17.2825C17.3671 32.3395 17.4258 30.9612 17.04 29.9212C15.4526 26.408 13.2625 24.4299 9.76067 23.3684C9.29403 25.0271 10.0583 25.4882 11.3775 26.2841C12.2447 26.8085 13.325 27.4615 14.1371 28.663C14.2583 28.8416 14.2106 29.0845 14.0305 29.2051C13.8527 29.3253 13.61 29.2794 13.4904 29.1C12.7738 28.0413 11.8184 27.463 10.9733 26.9529C9.632 26.1452 8.36794 25.3794 9.02942 23.0945C7.79841 22.3993 6.93122 20.5466 6.88349 19.9439C6.39841 16.2002 6.09341 13.7992 6.05669 13.4902C5.91161 12.7028 5.58591 10.9691 4.37739 11.0617C4.17466 11.0949 4.12567 11.1764 4.00255 11.338C3.99153 11.348 3.80411 11.596 3.84458 12.8707L3.84825 12.9089C3.9438 14.7929 4.03935 16.1727 4.10177 17.0858C4.1495 17.759 4.18263 18.2051 4.1863 18.4799C4.38474 22.5484 4.82935 24.2498 5.11966 25.3753L5.17114 25.5748C5.45044 26.3348 5.92075 26.9862 6.69606 27.6845C7.39395 28.3009 9.39817 29.8805 9.65411 30.2207ZM20.0018 6.65445C17.2201 6.65445 14.9565 8.91648 14.9565 11.6975C14.9565 14.4784 17.22 16.7409 20.0018 16.7409C22.7797 16.7409 25.0433 14.4784 25.0433 11.6975C25.0433 8.91648 22.7797 6.65445 20.0018 6.65445ZM20.0018 5.8732C16.7901 5.8732 14.1775 8.48586 14.1775 11.6974C14.1775 14.9094 16.7902 17.522 20.0018 17.522C23.2133 17.522 25.826 14.9094 25.826 11.6974C25.826 8.48586 23.2133 5.8732 20.0018 5.8732ZM22.4711 10.0847C22.3277 9.92265 22.0815 9.9068 21.9199 10.0494L19.1309 12.5022L18.1167 11.3565C18.048 11.279 17.9514 11.232 17.848 11.2257C17.7447 11.2194 17.6431 11.2544 17.5655 11.323C17.5271 11.3571 17.4957 11.3983 17.4733 11.4445C17.4508 11.4906 17.4376 11.5407 17.4346 11.592C17.4315 11.6432 17.4386 11.6945 17.4554 11.743C17.4722 11.7915 17.4984 11.8362 17.5325 11.8746L18.8039 13.3117C18.9464 13.4727 19.194 13.4884 19.355 13.3459L22.4343 10.6359C22.596 10.4933 22.6107 10.2467 22.4711 10.0847Z"
											fill="#F1C295"
										/>
									</svg>

									<div className="flex-1 pl-6 pr-16">
										<div className="flex text-[#707070] text-sm justify-between">
											<p>Life Management</p>
											<p>55%</p>
										</div>
										<div class="w-full bg-[#F3EDED] rounded-full h-4">
											<div
												class="bg-[#F1C295] h-4 rounded-full"
												style={{ width: "55%" }}
											></div>
										</div>
									</div>

									<svg
										width="24"
										height="24"
										viewBox="0 0 24 24"
										fill="none"
										xmlns="http://www.w3.org/2000/svg"
									>
										<path
											d="M7.1499 21.1C6.8999 20.85 6.7749 20.554 6.7749 20.212C6.7749 19.87 6.8999 19.5743 7.1499 19.325L14.4749 12L7.1249 4.65C6.89157 4.41667 6.7749 4.125 6.7749 3.775C6.7749 3.425 6.8999 3.125 7.1499 2.875C7.3999 2.625 7.6959 2.5 8.0379 2.5C8.3799 2.5 8.67557 2.625 8.9249 2.875L17.3249 11.3C17.4249 11.4 17.4959 11.5083 17.5379 11.625C17.5799 11.7417 17.6006 11.8667 17.5999 12C17.5999 12.1333 17.5789 12.2583 17.5369 12.375C17.4949 12.4917 17.4242 12.6 17.3249 12.7L8.8999 21.125C8.66657 21.3583 8.3789 21.475 8.0369 21.475C7.6949 21.475 7.39924 21.35 7.1499 21.1Z"
											fill="#A7AFB2"
										/>
									</svg>
								</div>

								{/* 3 */}
								<div className="flex items-end mb-2">
									<svg
										width="40"
										height="40"
										viewBox="0 0 40 40"
										fill="none"
										xmlns="http://www.w3.org/2000/svg"
									>
										<g clip-path="url(#clip0_38_1376)">
											<path
												d="M27.3462 13.5208H20.3866C20.0585 13.5208 19.7773 13.2396 19.7773 12.8881C19.7773 12.5366 20.0585 12.2554 20.3866 12.2554H27.3462C28.1898 12.2554 28.8225 11.6227 28.8225 10.7791V4.92091C28.8225 4.56942 29.1036 4.28823 29.4551 4.28823C29.8066 4.28823 30.0878 4.56942 30.0878 4.92091V10.7791C30.0878 12.2789 28.8459 13.5208 27.3462 13.5208ZM28.5178 17.106H20.3866C20.0585 17.106 19.7773 16.8248 19.7773 16.4733C19.7773 16.1453 20.0585 15.8641 20.3866 15.8641H28.3538L33.8137 12.6538C34.1183 12.4897 34.4932 12.5835 34.6807 12.8881C34.8447 13.1927 34.751 13.5677 34.4464 13.7317L28.8225 17.0123C28.7287 17.0826 28.635 17.106 28.5178 17.106Z"
												fill="#97EA56"
											/>
											<path
												d="M29.4551 5.5536C27.9554 5.5536 26.7135 4.31166 26.7135 2.81195C26.7135 1.24195 27.932 0 29.4551 0C31.0486 0 32.2671 1.21851 32.2671 2.81195C32.2671 4.33509 31.0251 5.5536 29.4551 5.5536ZM35.782 14.5284C34.1886 14.5284 32.9701 13.3333 32.9701 11.7868C32.9701 10.2402 34.212 8.97481 35.782 8.97481C37.2817 8.97481 38.5002 10.2402 38.5002 11.7868C38.5237 13.3099 37.2817 14.5284 35.782 14.5284ZM33.6028 20.621H20.3866C20.0585 20.621 19.7773 20.3398 19.7773 19.9883C19.7773 19.6602 20.0585 19.379 20.3866 19.379H33.6028C33.9308 19.379 34.212 19.6602 34.212 19.9883C34.212 20.3398 33.9308 20.621 33.6028 20.621Z"
												fill="#97EA56"
											/>
											<path
												d="M35.782 22.8002C34.212 22.8002 32.9701 21.5583 32.9701 19.9883C32.9701 18.4417 34.212 17.1763 35.782 17.1763C37.2817 17.1763 38.5002 18.4417 38.5002 19.9883C38.5002 21.5583 37.2817 22.8002 35.782 22.8002ZM29.4551 35.6883C29.1036 35.6883 28.8225 35.4071 28.8225 35.0791V29.2209C28.8225 28.3773 28.1898 27.7211 27.3462 27.7211H20.3866C20.0585 27.7211 19.7773 27.4399 19.7773 27.1119C19.7773 26.7604 20.0585 26.4792 20.3866 26.4792H27.3462C28.8459 26.4792 30.0878 27.6977 30.0878 29.2209V35.0791C30.0878 35.4071 29.8066 35.6883 29.4551 35.6883ZM34.1417 27.4165C34.0246 27.4165 33.9074 27.3931 33.8137 27.3228L28.3538 24.1359H20.3866C20.0585 24.1359 19.7773 23.8547 19.7773 23.5032C19.7773 23.1752 20.0585 22.894 20.3866 22.894H28.5178C28.635 22.894 28.7287 22.9174 28.8225 22.9643L34.4464 26.2449C34.751 26.4323 34.8447 26.8073 34.6807 27.1119C34.5635 27.2994 34.3526 27.4165 34.1417 27.4165Z"
												fill="#97EA56"
											/>
											<path
												d="M29.455 40C27.9318 40 26.7133 38.7581 26.7133 37.1881C26.7133 35.6649 27.9553 34.4464 29.455 34.4464C31.025 34.4464 32.2669 35.6415 32.2669 37.1881C32.2669 38.7815 31.0484 40 29.455 40ZM35.7819 31.0018C34.2119 31.0018 32.9699 29.7598 32.9699 28.1898C32.9699 26.6667 34.1884 25.4716 35.7819 25.4716C37.2816 25.4716 38.5001 26.6901 38.5001 28.1898C38.5235 29.7598 37.2816 31.0018 35.7819 31.0018ZM20.3864 39.2033H16.0982C15.7467 39.2033 15.4655 38.9221 15.4655 38.594V35.1494C13.3331 34.4464 11.3882 33.3216 9.6776 31.775L6.65475 33.5794C6.51415 33.6731 6.32669 33.6965 6.16266 33.6497C5.99863 33.6028 5.88146 33.4856 5.78773 33.345L1.56981 25.9168C1.49951 25.7762 1.47607 25.6122 1.49951 25.4482C1.54637 25.2841 1.66354 25.1435 1.80414 25.0732L4.82698 23.3626C4.56922 22.2847 4.45206 21.1365 4.45206 19.9883C4.45206 18.8401 4.56922 17.7153 4.82698 16.6374L1.80414 14.9268C1.66354 14.833 1.54637 14.6924 1.49951 14.5518C1.45264 14.3878 1.47607 14.2238 1.56981 14.0598L5.78773 6.65495C5.88146 6.49092 5.99863 6.39719 6.16266 6.35032C6.32669 6.30346 6.51415 6.32689 6.65475 6.42062L9.6776 8.20152C11.3882 6.67838 13.3331 5.5536 15.4655 4.85062V1.40598C15.4655 1.05448 15.7467 0.773287 16.0982 0.773287H20.3864C20.7379 0.773287 21.0191 1.05448 21.0191 1.40598V11.1072C16.2857 11.3181 12.4661 15.208 12.4661 19.9883C12.4661 24.792 16.2857 28.6585 21.0191 28.8928V38.594C21.0191 38.9221 20.7379 39.2033 20.3864 39.2033ZM21.0191 11.7165V28.2601H20.8082C16.4966 27.9086 13.0988 24.3468 13.0988 19.9883C13.0988 15.6532 16.4966 12.068 20.8082 11.7399L21.0191 11.7165Z"
												fill="#97EA56"
											/>
										</g>
										<defs>
											<clipPath id="clip0_38_1376">
												<rect width="40" height="40" fill="white" />
											</clipPath>
										</defs>
									</svg>

									<div className="flex-1 pl-6 pr-16">
										<div className="flex text-[#707070] text-sm justify-between">
											<p>Micro-Learning</p>
											<p>20%</p>
										</div>
										<div class="w-full bg-[#F3EDED] rounded-full h-4">
											<div
												class="bg-[#97EA56] h-4 rounded-full"
												style={{ width: "20%" }}
											></div>
										</div>
									</div>

									<svg
										width="24"
										height="24"
										viewBox="0 0 24 24"
										fill="none"
										xmlns="http://www.w3.org/2000/svg"
									>
										<path
											d="M7.1499 21.1C6.8999 20.85 6.7749 20.554 6.7749 20.212C6.7749 19.87 6.8999 19.5743 7.1499 19.325L14.4749 12L7.1249 4.65C6.89157 4.41667 6.7749 4.125 6.7749 3.775C6.7749 3.425 6.8999 3.125 7.1499 2.875C7.3999 2.625 7.6959 2.5 8.0379 2.5C8.3799 2.5 8.67557 2.625 8.9249 2.875L17.3249 11.3C17.4249 11.4 17.4959 11.5083 17.5379 11.625C17.5799 11.7417 17.6006 11.8667 17.5999 12C17.5999 12.1333 17.5789 12.2583 17.5369 12.375C17.4949 12.4917 17.4242 12.6 17.3249 12.7L8.8999 21.125C8.66657 21.3583 8.3789 21.475 8.0369 21.475C7.6949 21.475 7.39924 21.35 7.1499 21.1Z"
											fill="#A7AFB2"
										/>
									</svg>
								</div>

								{/* 4 */}
								<div className="flex items-end mb-2">
									<svg
										width="40"
										height="40"
										viewBox="0 0 40 40"
										fill="none"
										xmlns="http://www.w3.org/2000/svg"
									>
										<g clip-path="url(#clip0_38_1392)">
											<path
												d="M13.4398 23.84V21.68C13.4398 21.04 14.0798 20.4 14.7198 20.4H16.7198C17.3598 20.4 17.9998 19.92 17.9998 19.2V15.68C17.9998 15.36 18.2398 15.12 18.5598 15.12H19.5198C20.0798 15.12 20.6398 14.64 20.6398 14C20.6398 13.76 20.5598 13.6 20.3998 13.36L18.7998 10.96C18.6398 10.8 18.5598 10.56 18.5598 10.32L18.4798 9.12C18.3198 6.72 17.2798 4.64 15.6798 3.12C14.0798 1.6 11.9198 0.720001 9.5998 0.720001C4.7198 0.800001 0.799805 4.8 0.799805 9.76C0.799805 10.8 1.0398 11.84 1.4398 12.8L2.7998 15.68C3.8398 18 4.3998 20.48 4.3998 23.04V23.84H13.4398ZM4.3198 9.52V9.12C4.3198 8.72 4.6398 8.4 5.0398 8.32C5.3598 8.24 5.5998 8 5.6798 7.76C5.6798 7.68 5.7598 7.6 5.7598 7.6C5.8398 7.52 5.8398 7.36 5.8398 7.28C5.8398 7.12 5.7598 6.96 5.6798 6.8C5.4398 6.4 5.4398 6 5.7598 5.68L6.0798 5.36C6.2398 5.2 6.3998 5.2 6.6398 5.2C6.7998 5.2 6.9598 5.28 7.1198 5.36C7.3598 5.52 7.6798 5.6 7.9198 5.44C7.9998 5.44 8.0798 5.36 8.0798 5.36C8.3198 5.28 8.5598 5.04 8.5598 4.72C8.6398 4.32 8.9598 4 9.3598 4H9.7598C10.1598 4 10.4798 4.32 10.5598 4.72C10.6398 5.04 10.7998 5.28 11.0398 5.36C11.1198 5.36 11.1998 5.44 11.1998 5.44C11.2798 5.52 11.4398 5.52 11.5198 5.52C11.6798 5.52 11.8398 5.44 11.9998 5.36C12.3198 5.12 12.7998 5.12 13.0398 5.44L13.3598 5.76C13.5198 5.92 13.5998 6.16 13.5998 6.32C13.5998 6.48 13.5198 6.64 13.4398 6.8C13.2798 7.04 13.1998 7.36 13.3598 7.6C13.3598 7.68 13.4398 7.76 13.4398 7.76C13.5198 8 13.7598 8.24 14.0798 8.24C14.4798 8.32 14.7998 8.64 14.7998 9.04V9.44C14.7998 9.84 14.4798 10.16 14.0798 10.24C13.7598 10.32 13.5198 10.48 13.4398 10.72C13.4398 10.8 13.3598 10.88 13.3598 10.88C13.2798 10.96 13.2798 11.12 13.2798 11.2C13.2798 11.36 13.3598 11.52 13.4398 11.68C13.6798 12 13.6798 12.48 13.3598 12.72L13.0398 13.04C12.8798 13.2 12.6398 13.28 12.4798 13.28C12.3198 13.28 12.1598 13.2 11.9998 13.12C11.7598 12.96 11.4398 12.88 11.1998 13.04C11.1198 13.04 11.0398 13.12 11.0398 13.12C10.7998 13.2 10.5598 13.44 10.5598 13.76C10.4798 14.16 10.1598 14.48 9.7598 14.48H9.3598C8.9598 14.48 8.6398 14.16 8.5598 13.76C8.4798 13.44 8.3198 13.2 8.0798 13.12C7.9998 13.12 7.9198 13.04 7.9198 13.04C7.8398 12.96 7.6798 12.96 7.5998 12.96C7.4398 12.96 7.2798 13.04 7.1198 13.12C6.7998 13.36 6.3198 13.36 6.0798 13.04L5.7598 12.72C5.5998 12.56 5.5198 12.32 5.5198 12.16C5.5198 12 5.5998 11.84 5.6798 11.68C5.8398 11.44 5.9198 11.12 5.7598 10.88C5.7598 10.8 5.6798 10.72 5.6798 10.72C5.5998 10.48 5.3598 10.24 5.0398 10.24C4.6398 10.24 4.3198 9.92 4.3198 9.52ZM29.9998 33.84C29.9998 34 30.1598 34.16 30.3198 34.16C30.4798 34.16 30.7198 34 30.7198 33.84V32.64H29.9998V33.84ZM30.7998 22H30.3198C28.1598 22 26.3998 23.76 26.3998 25.92C26.3998 27.04 26.8798 28.16 27.7598 28.88C28.3998 29.44 28.7998 30.32 28.7998 31.2C28.7998 31.28 28.8798 31.36 28.9598 31.36H29.6798V28.08H29.2798C28.9598 28.08 28.6398 27.76 28.6398 27.44C28.6398 27.12 28.8798 26.8 29.2798 26.8H31.3598C31.6798 26.8 31.9998 27.04 31.9998 27.44C31.9998 27.76 31.7598 28.08 31.3598 28.08H30.9598V31.36H31.7598C31.8398 31.36 31.9198 31.28 31.9198 31.2C31.9198 30.32 32.3198 29.44 32.9598 28.8C33.9198 27.92 34.3998 26.56 34.2398 25.2C33.9998 23.52 32.5598 22.16 30.7998 22Z"
												fill="#ACE6F2"
											/>
											<path
												d="M30.3996 16.16C25.7596 16.16 21.8396 19.84 21.5996 24.56L21.5196 25.76C21.5196 26 21.4396 26.16 21.2796 26.4L19.6796 28.8C19.5196 28.96 19.4396 29.2 19.4396 29.44C19.4396 30 19.9996 30.56 20.5596 30.56H21.5196C21.8396 30.56 22.0796 30.8 22.0796 31.12V34.64C22.0796 35.28 22.6396 35.84 23.3596 35.84H25.3596C25.9996 35.84 26.6396 36.48 26.6396 37.12V39.2H35.6796V38.4C35.6796 35.84 36.2396 33.36 37.2796 31.04L38.6396 28.16C39.0396 27.2 39.2796 26.16 39.2796 25.12C39.1996 20.16 35.2796 16.16 30.3996 16.16ZM33.8396 29.76C33.4396 30.16 33.1996 30.64 33.1996 31.2C33.1996 31.92 32.6396 32.48 31.9996 32.64V33.92C31.9996 34.8 31.2796 35.52 30.3996 35.52C29.5196 35.52 28.7996 34.8 28.7996 33.92V32.64C28.1596 32.56 27.5996 31.92 27.5996 31.28C27.5996 30.72 27.3596 30.16 27.0396 29.84C25.9196 28.88 25.2796 27.44 25.2796 25.92C25.2796 22.88 27.9196 20.4 31.0396 20.8C33.2796 21.04 35.1996 22.88 35.5996 25.12C35.7596 26.8 35.1196 28.56 33.8396 29.76ZM20.0796 3.68H30.6396C32.3196 3.68 33.6796 5.04 33.6796 6.72V11.84L33.0396 11.2C32.7996 10.96 32.3996 10.96 32.1596 11.2C31.9196 11.44 31.9196 11.84 32.1596 12.08L33.8396 13.76C33.9196 13.84 33.9996 13.84 34.0796 13.92C34.1596 13.92 34.2396 14 34.3196 14C34.3996 14 34.4796 14 34.5596 13.92C34.6396 13.92 34.7196 13.84 34.7996 13.76L36.4796 12.08C36.7196 11.84 36.7196 11.44 36.4796 11.2C36.2396 10.96 35.8396 10.96 35.5996 11.2L34.9596 11.84V6.72C34.9596 4.32 33.0396 2.4 30.6396 2.4H20.0796C19.7596 2.4 19.4396 2.64 19.4396 3.04C19.4396 3.36 19.7596 3.68 20.0796 3.68ZM18.7996 36.08H11.1196C9.43961 36.08 8.07961 34.72 8.07961 33.04V28.56L8.71961 29.2C8.87961 29.36 8.95961 29.36 9.11961 29.36C9.27961 29.36 9.43961 29.28 9.51961 29.2C9.75961 28.96 9.75961 28.56 9.51961 28.32L7.83961 26.64C7.75961 26.56 7.67961 26.56 7.59961 26.48C7.51961 26.4 7.35961 26.4 7.19961 26.48C7.11961 26.48 7.03961 26.56 6.95961 26.64L5.27961 28.32C5.03961 28.56 5.03961 28.96 5.27961 29.2C5.51961 29.44 5.91961 29.44 6.15961 29.2L6.79961 28.56V33.04C6.79961 35.44 8.71961 37.36 11.1196 37.36H18.7996C19.1196 37.36 19.4396 37.12 19.4396 36.72C19.4396 36.32 19.1196 36.08 18.7996 36.08ZM9.59961 10.8C10.3996 10.8 11.1196 10.16 11.1196 9.28C11.1196 8.48 10.4796 7.76 9.59961 7.76C8.79961 7.76 8.07961 8.4 8.07961 9.28C8.07961 10.08 8.79961 10.8 9.59961 10.8Z"
												fill="#ACE6F2"
											/>
										</g>
										<defs>
											<clipPath id="clip0_38_1392">
												<rect width="40" height="40" fill="white" />
											</clipPath>
										</defs>
									</svg>

									<div className="flex-1 pl-6 pr-16">
										<div className="flex text-[#707070] text-sm justify-between">
											<p>Knowledge Sharing</p>
											<p>90%</p>
										</div>
										<div class="w-full bg-[#F3EDED] rounded-full h-4">
											<div
												class="bg-[#ACE6F2] h-4 rounded-full"
												style={{ width: "90%" }}
											></div>
										</div>
									</div>

									<svg
										width="24"
										height="24"
										viewBox="0 0 24 24"
										fill="none"
										xmlns="http://www.w3.org/2000/svg"
									>
										<path
											d="M7.1499 21.1C6.8999 20.85 6.7749 20.554 6.7749 20.212C6.7749 19.87 6.8999 19.5743 7.1499 19.325L14.4749 12L7.1249 4.65C6.89157 4.41667 6.7749 4.125 6.7749 3.775C6.7749 3.425 6.8999 3.125 7.1499 2.875C7.3999 2.625 7.6959 2.5 8.0379 2.5C8.3799 2.5 8.67557 2.625 8.9249 2.875L17.3249 11.3C17.4249 11.4 17.4959 11.5083 17.5379 11.625C17.5799 11.7417 17.6006 11.8667 17.5999 12C17.5999 12.1333 17.5789 12.2583 17.5369 12.375C17.4949 12.4917 17.4242 12.6 17.3249 12.7L8.8999 21.125C8.66657 21.3583 8.3789 21.475 8.0369 21.475C7.6949 21.475 7.39924 21.35 7.1499 21.1Z"
											fill="#A7AFB2"
										/>
									</svg>
								</div>

								{/* 5 */}
								<div className="flex items-end mb-2">
									<svg
										width="40"
										height="40"
										viewBox="0 0 40 40"
										fill="none"
										xmlns="http://www.w3.org/2000/svg"
									>
										<g clip-path="url(#clip0_38_1406)">
											<path
												d="M11.6412 27.081C11.2613 25.0976 9.51438 23.5938 7.42188 23.5938C5.05258 23.5938 3.125 25.5213 3.125 27.8906C3.125 30.2599 5.05258 32.1875 7.42188 32.1875C9.10992 32.1875 10.573 31.2086 11.2753 29.7891L20 26.0411L28.7247 29.7891C29.427 31.2086 30.8901 32.1875 32.5781 32.1875C34.9474 32.1875 36.875 30.2599 36.875 27.8906C36.875 25.5213 34.9474 23.5938 32.5781 23.5938C30.4856 23.5938 28.7387 25.0976 28.3588 27.081L21.1719 23.9936V21.0938H18.8281V23.9936L11.6412 27.081Z"
												fill="#CC9FEF"
											/>
											<path
												d="M20 14.0625C21.5102 14.0625 22.7344 12.8383 22.7344 11.3281C22.7344 9.81797 21.5102 8.59375 20 8.59375C18.4898 8.59375 17.2656 9.81797 17.2656 11.3281C17.2656 12.8383 18.4898 14.0625 20 14.0625Z"
												fill="#CC9FEF"
											/>
											<path
												d="M14.9219 11.3281C14.9219 8.52805 17.1999 6.25 20 6.25C22.8001 6.25 25.0781 8.52805 25.0781 11.3281C25.0781 13.7248 23.4086 15.7377 21.1719 16.2683V21.0938H29.375C33.0366 21.0938 36.0156 18.1148 36.0156 14.4531C36.0156 11.1652 33.6138 8.42766 30.4723 7.90313C30.1905 5.87516 29.117 4.00789 27.3794 2.55977C25.3985 0.909063 22.7778 0 20 0C17.2222 0 14.6015 0.909063 12.6206 2.55984C10.883 4.00789 9.80953 5.87523 9.52766 7.9032C6.38625 8.42766 3.98438 11.1652 3.98438 14.4531C3.98438 18.1148 6.96336 21.0938 10.625 21.0938H18.8281V16.2683C16.5914 15.7377 14.9219 13.7248 14.9219 11.3281ZM12.2729 32.4188C11.06 33.7173 9.33469 34.5312 7.42188 34.5312C5.50906 34.5312 3.78375 33.7173 2.57086 32.4188C1.02039 33.4741 0 35.2528 0 37.2656V38.8281C0 39.4753 0.524687 40 1.17188 40H13.6719C14.3191 40 14.8438 39.4753 14.8438 38.8281V37.2656C14.8438 35.2528 13.8234 33.4741 12.2729 32.4188ZM37.4291 32.4188C36.2162 33.7173 34.4909 34.5312 32.5781 34.5312C30.6653 34.5312 28.94 33.7173 27.7271 32.4188C26.1766 33.4741 25.1562 35.2528 25.1562 37.2656V38.8281C25.1562 39.4753 25.6809 40 26.3281 40H38.8281C39.4753 40 40 39.4753 40 38.8281V37.2656C40 35.2528 38.9796 33.4741 37.4291 32.4188Z"
												fill="#CC9FEF"
											/>
										</g>
										<defs>
											<clipPath id="clip0_38_1406">
												<rect width="40" height="40" fill="white" />
											</clipPath>
										</defs>
									</svg>

									<div className="flex-1 pl-6 pr-16">
										<div className="flex text-[#707070] text-sm justify-between">
											<p>Cloud Bases</p>
											<p>65%</p>
										</div>
										<div class="w-full bg-[#F3EDED] rounded-full h-4">
											<div
												class="bg-[#CC9FEF] h-4 rounded-full"
												style={{ width: "65%" }}
											></div>
										</div>
									</div>

									<svg
										width="24"
										height="24"
										viewBox="0 0 24 24"
										fill="none"
										xmlns="http://www.w3.org/2000/svg"
									>
										<path
											d="M7.1499 21.1C6.8999 20.85 6.7749 20.554 6.7749 20.212C6.7749 19.87 6.8999 19.5743 7.1499 19.325L14.4749 12L7.1249 4.65C6.89157 4.41667 6.7749 4.125 6.7749 3.775C6.7749 3.425 6.8999 3.125 7.1499 2.875C7.3999 2.625 7.6959 2.5 8.0379 2.5C8.3799 2.5 8.67557 2.625 8.9249 2.875L17.3249 11.3C17.4249 11.4 17.4959 11.5083 17.5379 11.625C17.5799 11.7417 17.6006 11.8667 17.5999 12C17.5999 12.1333 17.5789 12.2583 17.5369 12.375C17.4949 12.4917 17.4242 12.6 17.3249 12.7L8.8999 21.125C8.66657 21.3583 8.3789 21.475 8.0369 21.475C7.6949 21.475 7.39924 21.35 7.1499 21.1Z"
											fill="#A7AFB2"
										/>
									</svg>
								</div>

								{/* 6 */}
								<div className="flex items-end mb-2">
									<svg
										width="40"
										height="40"
										viewBox="0 0 40 40"
										fill="none"
										xmlns="http://www.w3.org/2000/svg"
									>
										<path
											fill-rule="evenodd"
											clip-rule="evenodd"
											d="M19.6453 26.0758C13.5822 21.0361 10.3449 14.3623 10.264 6.74008C14.0489 5.6164 17.2384 3.9643 20.0017 1.6993C22.7613 3.9643 25.9508 5.6164 29.7357 6.74008C29.6439 13.9033 26.0685 20.7487 19.6453 26.0758ZM36.1553 12.8707C36.1957 11.596 36.0083 11.348 36.0009 11.338C35.8792 11.197 35.8473 11.0985 35.6224 11.0617C34.4129 10.969 34.091 12.7034 33.9431 13.4902C33.9064 13.7993 33.6013 16.2002 33.1163 19.9439C33.0686 20.5466 32.2013 22.3993 30.9704 23.0945C31.6318 25.3794 30.3677 26.1452 29.0265 26.9529C28.1814 27.463 27.226 28.0413 26.5094 29.1C26.4359 29.2117 26.311 29.2719 26.1861 29.2719C25.8817 29.2719 25.6851 28.9252 25.8627 28.663C26.6748 27.4615 27.7551 26.8085 28.626 26.2841C29.9415 25.4882 30.7058 25.027 30.2391 23.3684C26.7372 24.43 24.5472 26.408 22.9597 29.9212C22.574 30.9612 22.6364 32.3395 22.7172 33.9328H29.7577C29.754 32.8198 29.8239 30.9068 30.3457 30.2207C30.5979 29.8871 32.6055 28.3011 33.3074 27.6805C34.079 26.9863 34.5494 26.3348 34.8287 25.5749L34.8802 25.3754C35.1705 24.2498 35.6151 22.5485 35.8136 18.48C35.8172 18.2052 35.8504 17.7591 35.8981 17.0859C35.9605 16.1727 36.0561 14.7929 36.1516 12.909L36.1553 12.8707ZM31.9111 35.1825V37.8323C31.9111 38.0906 31.7016 38.3008 31.4408 38.3008H22.0595C21.8022 38.3008 21.5928 38.0906 21.5928 37.8323V35.1825C21.5928 34.9241 21.8022 34.714 22.0595 34.714H31.4408C31.7016 34.714 31.9111 34.9241 31.9111 35.1825ZM18.4069 37.8323C18.4069 38.0906 18.1975 38.3008 17.9403 38.3008H8.55903C8.30185 38.3008 8.08864 38.0906 8.08864 37.8323V35.1825C8.08864 34.9241 8.30177 34.714 8.55903 34.714H17.9403C18.1975 34.714 18.4069 34.9241 18.4069 35.1825V37.8323ZM9.65411 30.2207C10.1759 30.9067 10.2457 32.8198 10.242 33.9328H17.2825C17.3671 32.3395 17.4258 30.9612 17.04 29.9212C15.4526 26.408 13.2625 24.4299 9.76067 23.3684C9.29403 25.0271 10.0583 25.4882 11.3775 26.2841C12.2447 26.8085 13.325 27.4615 14.1371 28.663C14.2583 28.8416 14.2106 29.0845 14.0305 29.2051C13.8527 29.3253 13.61 29.2794 13.4904 29.1C12.7738 28.0413 11.8184 27.463 10.9733 26.9529C9.632 26.1452 8.36794 25.3794 9.02942 23.0945C7.79841 22.3993 6.93122 20.5466 6.88349 19.9439C6.39841 16.2002 6.09341 13.7992 6.05669 13.4902C5.91161 12.7028 5.58591 10.9691 4.37739 11.0617C4.17466 11.0949 4.12567 11.1764 4.00255 11.338C3.99153 11.348 3.80411 11.596 3.84458 12.8707L3.84825 12.9089C3.9438 14.7929 4.03935 16.1727 4.10177 17.0858C4.1495 17.759 4.18263 18.2051 4.1863 18.4799C4.38474 22.5484 4.82935 24.2498 5.11966 25.3753L5.17114 25.5748C5.45044 26.3348 5.92075 26.9862 6.69606 27.6845C7.39395 28.3009 9.39817 29.8805 9.65411 30.2207ZM20.0018 6.65445C17.2201 6.65445 14.9565 8.91648 14.9565 11.6975C14.9565 14.4784 17.22 16.7409 20.0018 16.7409C22.7797 16.7409 25.0433 14.4784 25.0433 11.6975C25.0433 8.91648 22.7797 6.65445 20.0018 6.65445ZM20.0018 5.8732C16.7901 5.8732 14.1775 8.48586 14.1775 11.6974C14.1775 14.9094 16.7902 17.522 20.0018 17.522C23.2133 17.522 25.826 14.9094 25.826 11.6974C25.826 8.48586 23.2133 5.8732 20.0018 5.8732ZM22.4711 10.0847C22.3277 9.92265 22.0815 9.9068 21.9199 10.0494L19.1309 12.5022L18.1167 11.3565C18.048 11.279 17.9514 11.232 17.848 11.2257C17.7447 11.2194 17.6431 11.2544 17.5655 11.323C17.5271 11.3571 17.4957 11.3983 17.4733 11.4445C17.4508 11.4906 17.4376 11.5407 17.4346 11.592C17.4315 11.6432 17.4386 11.6945 17.4554 11.743C17.4722 11.7915 17.4984 11.8362 17.5325 11.8746L18.8039 13.3117C18.9464 13.4727 19.194 13.4884 19.355 13.3459L22.4343 10.6359C22.596 10.4933 22.6107 10.2467 22.4711 10.0847Z"
											fill="#F1C295"
										/>
									</svg>

									<div className="flex-1 pl-6 pr-16">
										<div className="flex text-[#707070] text-sm justify-between">
											<p>Life Management</p>
											<p>55%</p>
										</div>
										<div class="w-full bg-[#F3EDED] rounded-full h-4">
											<div
												class="bg-[#F1C295] h-4 rounded-full"
												style={{ width: "55%" }}
											></div>
										</div>
									</div>

									<svg
										width="24"
										height="24"
										viewBox="0 0 24 24"
										fill="none"
										xmlns="http://www.w3.org/2000/svg"
									>
										<path
											d="M7.1499 21.1C6.8999 20.85 6.7749 20.554 6.7749 20.212C6.7749 19.87 6.8999 19.5743 7.1499 19.325L14.4749 12L7.1249 4.65C6.89157 4.41667 6.7749 4.125 6.7749 3.775C6.7749 3.425 6.8999 3.125 7.1499 2.875C7.3999 2.625 7.6959 2.5 8.0379 2.5C8.3799 2.5 8.67557 2.625 8.9249 2.875L17.3249 11.3C17.4249 11.4 17.4959 11.5083 17.5379 11.625C17.5799 11.7417 17.6006 11.8667 17.5999 12C17.5999 12.1333 17.5789 12.2583 17.5369 12.375C17.4949 12.4917 17.4242 12.6 17.3249 12.7L8.8999 21.125C8.66657 21.3583 8.3789 21.475 8.0369 21.475C7.6949 21.475 7.39924 21.35 7.1499 21.1Z"
											fill="#A7AFB2"
										/>
									</svg>
								</div>
							</div>
						</div>
					</div>

					{/* bottom row */}
					<div className="mt-4 flex justify-between flex-wrap">
						{/* left card */}
						<div className="h-96 w-full xl:w-[60%] mt-4 bg-white flex flex-col p-4 rounded-md shadow">
							{/* heading and select */}
							<div className="flex justify-between mb-2">
								<Components.Paragraph className="!text-lg !font-bold">
									Overall Activity
								</Components.Paragraph>

								<select
									name=""
									id=""
									className="focus:outline-none border border-[#A7AFB2] p-2 rounded text-sm text-[#A7AFB2]"
								>
									<option value="">Filter</option>
								</select>
							</div>

							{/* graph */}
							<div className="flex flex-col items-center justify-center flex-1 w-full overflow-hidden">
								{/* bottom */}
								<div className="flex-1 w-full overflow-hidden">
									<Line
										options={lineOptions}
										data={lineData}
										style={{ width: "100%", height: "100%" }}
									/>
								</div>
							</div>
						</div>

						{/* right card */}
						<div className="h-96 w-full xl:w-auto flex-1 mt-3 xl:mt-4 xl:ml-4 bg-white flex flex-col p-4 rounded-md shadow">
							{/* heading and select */}
							<div className="flex justify-between">
								<Components.Paragraph className="!text-lg !font-bold">
									Overall Progress
								</Components.Paragraph>
							</div>

							{/* graph */}
							<div className="flex flex-col items-center justify-center flex-1 w-full overflow-hidden">
								{/* bottom */}
								<div className="relative flex-1 w-full overflow-hidden flex items-center justify-center">
									<Doughnut options={doughnutOptions} data={doughnutData} />

									<div className="absolute text-center font-medium text-3xl bg-black text-white h-28 aspect-square rounded-full flex items-center justify-center">
										70%
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	);
}
